export default {"src":"/_next/static/media/faq.d4748d54.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};